import { render, staticRenderFns } from "./ViqShareDialog.vue?vue&type=template&id=a5909696&scoped=true"
import script from "./ViqShareDialog.vue?vue&type=script&lang=js"
export * from "./ViqShareDialog.vue?vue&type=script&lang=js"
import style0 from "./ViqShareDialog.vue?vue&type=style&index=0&id=a5909696&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5909696",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5909696')) {
      api.createRecord('a5909696', component.options)
    } else {
      api.reload('a5909696', component.options)
    }
    module.hot.accept("./ViqShareDialog.vue?vue&type=template&id=a5909696&scoped=true", function () {
      api.rerender('a5909696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqShareDialog.vue"
export default component.exports